/** @format */

export default class VersionCheck {
    getVersion = (): string => {
        return '';
    };
}
